import { cva } from 'class-variance-authority';

export type CheckboxSize = 'standard' | 'sm';

/**
 * Box visuals shared by the interactive Checkbox and the presentational CheckboxIndicator.
 * State is driven by the `data-state` / `data-disabled` attributes Radix sets, so any element
 * mirroring that contract gets the same appearance.
 */
export const checkboxVariants = cva(
  [
    'shrink-0 border-1 border-border-field bg-surface-primary',
    // Checked
    '[&[data-state=checked]:not([data-disabled])]:border-transparent [&[data-state=checked]:not([data-disabled])]:bg-action-primary [&[data-state=checked]:not([data-disabled])]:hover:border-action-primary-hover',
    // Disabled
    'data-[disabled]:border-border-disabled data-[disabled]:bg-surface-secondary',
    // Disabled checked
    'data-[state=checked]:data-disabled:border-transparent data-[state=checked]:data-disabled:bg-action-primary-disabled',
  ],
  {
    variants: {
      size: {
        standard: 'h-6 w-6 rounded-lg',
        sm: 'h-4 w-4 rounded-sm',
      },
    },
    defaultVariants: {
      size: 'standard',
    },
  },
);

export const checkboxIconSize: Record<CheckboxSize, number> = {
  standard: 16,
  sm: 10,
};
